<ion-row class="th-text" [ngClass]="{ 'align-header-right': rightAlign }">
  {{ columnName }}
</ion-row>
<ion-row
  class="search-wrapper"
  [ngClass]="{ 'align-search-right': rightAlign }"
>
  <ion-col size="11">
    <ion-input
      class="input-container"
      fill="outline"
      [type]="inputType === InputType.time ? InputType.text : inputType"
      [maxlength]="maxLength"
      [formControl]="control"
      [placeholder]="placeholder"
      [autocapitalize]="autoCapitalizeCharacters"
      (keyup)="search($event)"
      (keypress)="preventSpecialCharacters($event)"
    >
    </ion-input>
    <div
      class="clear-search-text-icons"
      onkeypress="clearText()"
      (click)="clearText()"
    >
      <img
        alt="cancel"
        [src]="control.value.length > 0 ? IMAGE_SRC.CLEAR : IMAGE_SRC.SEARCH"
        [ngClass]="{ 'active-click': control.value.length > 0 }"
      />
    </div>
  </ion-col>
</ion-row>
